import { render, staticRenderFns } from "./investment-level-panel-placeholder.vue?vue&type=template&id=37c02ad0&scoped=true&"
import script from "./investment-level-panel-placeholder.vue?vue&type=script&lang=ts&"
export * from "./investment-level-panel-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./investment-level-panel-placeholder.vue?vue&type=style&index=0&id=37c02ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c02ad0",
  null
  
)

export default component.exports